import Vue from 'vue'
import Router from 'vue-router'
import Paynow from '@/components/modules/paynow/Paynow'
import PaynowCheckout from '@/components/modules/paynow/PaynowCheckout'
import PaynowChoosePaymentMethod from '@/components/modules/paynow/PaynowChoosePaymentMethod'
import PaynowAddPaymentMethod from '@/components/modules/paynow/PaynowAddPaymentMethod'
import ThankyouComponent from '@/components/modules/paynow/PaynowThankyouComponent'
import ErrorComponent from "@/components/modules/hosted-pages/ErrorComponent/"
import GocardlessGuarantee from "@/components/modules/hosted-pages/payment-methods/direct-debit/GocardlessGuarantee"
import UpiTimer from "@/components/modules/hosted-pages/payment-methods/UpiTimer"
import PaymentLoader from "@/components/modules/hosted-pages/payment-methods/PaymentLoader"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/pages/v3/:token/collect_now',
      component: Paynow,
      name: "main",
      children: [
        {
          path: 'paynow',
          name: "paynow",
          component: PaynowCheckout,
          children: [
		        {
              path: "choose_pm",
              component: PaynowChoosePaymentMethod,
              name: "choose_pm",
              meta: {header: "header-1", "headerLogo":true, headerTitle: "header.choosepm.txt", "isHeaderTitle":true }
            },
            {
              path: "guarantee_pm",
              component: GocardlessGuarantee,
              name: "paynow_gocardless_guarantee",
              meta: {header: "header-2", "isHeaderTitle":true, headerTitle: "payment_method.bacs.guarantee.header"},
            },
            {
              path: "add_pm",
              component: PaynowAddPaymentMethod,
              name: "add_pm",
              meta: {
                header: "header-1", 
                headerLogo: true, 
                headerTitle: "header.addpm.txt", 
                isHeaderTitle:true,
                headerType: (route) => {
                  return (route.query.mode == "edit" || route.query.mode == "empty") ?
                    "header-2" : "header-1";
                },
              }
            },
            {
              path: "thankyou",
              component: ThankyouComponent,
              name: "thankyou",
              meta: {"header": "header-thankyou", "headerLogo": true, "isHeaderTitle": false},
            },
            {
              path: "upi_timer",
              component: UpiTimer,
              name: "upi_timer",
              meta: {"header": "header-1", "headerTitle":"upi_loader.header",  commonTranslate: true, "isHeaderTitle":true, "headerLogo":true,}
            },
            {
              path: "awaiting_for_confirmation",
              component: PaymentLoader,
              name: "awaiting_for_confirmation",
              meta: {"header": "header-1", "headerTitle":"payment_loader.header",  commonTranslate: true, "isHeaderTitle":true, "headerLogo":true,}
            },
          ]
        },
    	]
    },
    {
      path: '/pages/v3/:token/error',
      component: ErrorComponent,
      name: "error"
    },
    {
      path: '/pages/v3/:token/*',
      redirect: {name: 'error'}
    },
  ]
})
